import React from 'react';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import WarehouseNavbar from './WarehouseNavbar';

const WarehouseLayout = () => (
  <ProtectedRoute allowedRoles={['warehouse', 'admin']}>
    <div className="min-h-screen bg-gray-50">
      <WarehouseNavbar />
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  </ProtectedRoute>
);

export default WarehouseLayout;
